<template>
  <b-modal
    id="modal-kinney"
    style="width: min-content; padding: 10px"
    hide-footer
    centered
    size="lg"
    @hidden="resetModal"
    :noCloseOnBackdrop="false"
    :noCloseOnEsc="false"
    :hideHeaderClose="false"
  >
    <div>
      <h1 class="title-modal-kinney">Método de KINNEY</h1>
      <b-overlay :show="isLoading" rounded="sm">
        <template #overlay>
          <OverlayButton clase="overlay-md"> </OverlayButton>
        </template>
        <div class="mt-5">
          <p>Donde R, es el Riesgo y está definido como:</p>
          <div class="content-formula">
            R = P x F x 1
          </div>
          <hr class="hr-filter-info" />
          <p>Donde P es probalidad, que puede ser:</p>
          <table class="table table-kinney">
            <thead>
              <tr>
                <th>Probabilidad</th>
                <th>Si el evento es:</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item) in data?.probability" :key="item?.id">
                <td>{{ item?.score }}</td>
                <td>{{ item?.event?.action }}</td>
              </tr>
            </tbody>
          </table>
          <hr class="hr-filter-info" />
          <p>Donde F es Frecuencia de exposicoión y puede ser:</p>
          <table class="table table-kinney">
            <thead>
              <tr>
                <th>Frecuencia</th>
                <th>Si la acción-evento ocurre</th>
                <th>Lo cual significa</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item) in data?.frequency" :key="item?.id">
                <td>{{ item?.score }}</td>
                <td>{{ item?.event?.action }}</td>
                <td></td>
              </tr>
            </tbody>
          </table>
          <hr class="hr-filter-info" />
          <p>Donde I es Impacto, y puede ser:</p>
          <table class="table table-kinney">
            <thead>
              <tr>
                <th>Impacto</th>
                <th>Cuando es factible es <br /> sigueinte impacto</th>
                <th>Lo cual significa</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item) in data?.impact" :key="item?.id">
                <td>{{ item?.score }}</td>
                <td>{{ item?.event?.action }}</td>
                <td></td>
              </tr>
            </tbody>
          </table>
          <hr class="hr-filter-info" />
          <p>Donde R es riesgo, Según el resultado de la evaluación tome las siguientes acciones</p>
          <table class="table table-kinney">
            <thead>
              <tr>
                <th>Puntaje</th>
                <th>Resultado de la evolución</th>
                <th>Lo cual significa</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item) in data?.risks" :key="item?.id">
                <td>{{ textScore(item?.score) }}</td>
                <td>
                  <div class="content-risks-activity mb-3">
                    <div class="risk-activity" :style="{
                      backgroundColor: item?.background,
                      color: item?.color
                    }" style="width: 100%;">
                      <img class="mr-2" :src="item?.icon" alt="">
                      <span :style="{ color: item?.color }">{{ item?.name }}</span>
                    </div>
                  </div>
                </td>
                <td>{{ item?.text }}</td>
              </tr>
            </tbody>
          </table>
          <p style="color: #0075FF;">Para mayor detalle, vea el VPO.SAFE.3.2.02. Evaluación de Riesgos</p>
          <div class="mt-4 d-flex justify-content-center">
            <button class="button_primary" @click.prevent="$bvModal.hide('modal-kinney')">Entendido</button>
          </div>
        </div>
      </b-overlay>
    </div>
  </b-modal>
</template>

<script>
import OverlayButton from "@/components/core/overlay/overlay-button.vue";

export default {
  components: { OverlayButton },
  props: {
    data: {
      type: Object,
      default: null,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    resetModal() {
      const me = this;
      me.formData = {
        name: "",
      };
    },
    textScore(score) {
      let text = "";
      if (score[0] === 0) {
        text = "0";
      } else if (score[0] === 19) {
        text = "Menos de 20"
      } else if (score[0] === 401) {
        text = "Más de 400";
      } else {
        text = `${score[0]} - ${score[1]}`;
      }

      return text;
    }
  },
};
</script>
<style lang="scss">
.button_primary {
  display: flex;
  align-items: center;
  background-color: #5d5fef;
  height: 40px;
  border-radius: 8px;
  font-size: 18px;
  gap: 10px;
  border: none;
  color: white;
  padding: 15px;
}
.title-modal-kinney {
  font-size: 18px;
}
.content-formula {
  background-color: #F6FFED;
  padding: 8px;
  border-radius: 8px;
  font-size: 18px;
  font-weight: 700;
}
</style>
